export const slotProps = {
  textField: {
    // TODO - unable to find spot in theme to provide this for x-date-pickers
    // currently, this is 4px less than muiTextField marginTop
    sx: { mt: "16px" },
  },
};
